import React from "react";
import { ShieldAlert, Scale, Gavel, UserCheck } from "lucide-react";
import SEO from "../../components/SEO";
import { useLanguage } from "../../context/LanguageContext";

export default function Terms() {
    const { t } = useLanguage();

    return (
        <div className="min-h-screen bg-spiritual-white dark:bg-gray-950 text-gray-800 dark:text-gray-100 font-body py-20 px-6">
            <SEO 
              title={t("terms_title")} 
              description={t("terms_disclaimer_1")} 
              url="/terms" 
            />
            <main className="max-w-4xl mx-auto space-y-12">

                {/* HEADER */}
                <div className="text-center space-y-4">
                    <h1 className="text-4xl font-display font-bold">{t("terms_title")}</h1>
                    <p className="text-gray-500">{t("terms_updated")}</p>
                </div>

                {/* 🚨 MEDICAL DISCLAIMER 🚨 */}
                <section className="bg-red-50 dark:bg-red-900/10 border-l-4 border-red-500 p-6 rounded-r-xl space-y-4">
                    <div className="flex items-center gap-3 text-red-700 dark:text-red-400 font-bold text-lg uppercase tracking-wide">
                        <ShieldAlert className="w-6 h-6" />
                        {t("terms_disclaimer_title")}
                    </div>
                    <div className="prose dark:prose-invert max-w-none text-red-900 dark:text-red-100 text-sm md:text-base leading-relaxed font-semibold">
                        <p>
                            {t("terms_disclaimer_1")}
                        </p>
                        <p>
                            {t("terms_disclaimer_2")}
                        </p>
                        <p>
                            {t("terms_disclaimer_3")}
                        </p>
                    </div>
                </section>

                {/* 1. NATURE OF SERVICE */}
                <section className="space-y-4">
                    <h2 className="text-2xl font-bold flex items-center gap-2">
                        <Scale className="w-6 h-6 text-brand-blue" />
                        {t("terms_sec1_title")}
                    </h2>
                    <p className="leading-relaxed text-gray-600 dark:text-gray-300">
                        {t("terms_sec1_p1")}
                    </p>
                    <p className="leading-relaxed text-gray-600 dark:text-gray-300">
                        {t("terms_sec1_p2")}
                    </p>
                    <p className="leading-relaxed text-gray-600 dark:text-gray-300">
                        {t("terms_sec1_p3")}
                    </p>
                </section>

                {/* 2. USER CONDUCT */}
                <section className="space-y-4">
                    <h2 className="text-2xl font-bold flex items-center gap-2">
                        <UserCheck className="w-6 h-6 text-brand-blue" />
                        {t("terms_sec2_title")}
                    </h2>
                    <ul className="list-disc pl-5 space-y-2 text-gray-600 dark:text-gray-300">
                        <li><strong>{t("terms_sec2_age")}</strong> {t("terms_sec2_age_desc")}</li>
                        <li><strong>{t("terms_sec2_zero")}</strong> {t("terms_sec2_zero_desc")}</li>
                        <li><strong>{t("terms_sec2_privacy")}</strong> {t("terms_sec2_privacy_desc")}</li>
                    </ul>
                </section>

                {/* 3. PROVIDER AGREEMENT */}
                <section className="space-y-4">
                    <h2 className="text-2xl font-bold flex items-center gap-2">
                        <Gavel className="w-6 h-6 text-brand-blue" />
                        {t("terms_sec3_title")}
                    </h2>
                    <div className="bg-blue-50 dark:bg-gray-800 p-6 rounded-xl border border-blue-100 dark:border-gray-700 space-y-3">
                        <p className="font-medium text-gray-800 dark:text-white">{t("terms_sec3_intro")}</p>
                        <ul className="list-disc pl-5 space-y-2 text-gray-600 dark:text-gray-300 text-sm">
                            <li>{t("terms_sec3_1")}</li>
                            <li>{t("terms_sec3_2")}</li>
                            <li>{t("terms_sec3_3")}</li>
                            <li>{t("terms_sec3_4")}</li>
                        </ul>
                    </div>
                </section>

                {/* 4. TERMINATION */}
                <section className="space-y-4">
                    <h2 className="text-2xl font-bold">{t("terms_sec4_title")}</h2>
                    <p className="leading-relaxed text-gray-600 dark:text-gray-300">
                        {t("terms_sec4_desc1")}
                    </p>
                    <p className="leading-relaxed text-gray-600 dark:text-gray-300">
                        {t("terms_sec4_desc2")}
                    </p>
                </section>

                {/* 5. LIMITATION OF LIABILITY */}
                <section className="space-y-4">
                    <h2 className="text-2xl font-bold">{t("terms_sec5_title")}</h2>
                    <p className="leading-relaxed text-gray-600 dark:text-gray-300 uppercase text-sm font-medium tracking-wide">
                        {t("terms_sec5_desc")}
                    </p>
                </section>

            </main>
        </div>
    );
}
